<template lang="html">

    <div class="dropzone row-center" :error="(errors.has('file') || errorformat)"
        :added="!!actualDoc.ficheroB64ParaAltas || !!fakeupload">

        <template v-if="!loading">

            <div class="text" v-if="!!!actualDoc.ficheroB64ParaAltas & !fakeupload">
                <span class="upload-icon-wrapper">
                    <upload-icon v-if="!errorformat && !!!errors.has('file')" class="tag-icon"></upload-icon>
                    <figure v-if="errorformat || errors.has('file')">✕</figure>
                </span>
                <p>{{textoUpload}}</p>
            </div>

            <div class="text" v-if="!!actualDoc.ficheroB64ParaAltas || !!fakeupload">
                <success-icon class="tag-icon"></success-icon>
                <p>Fichero <template v-if="!!actualDoc.nombre">{{actualDoc.nombre}}</template> añadido correctamente</p>
            </div>

            <a class="link" @click="eliminar" :show="!!actualDoc.ficheroB64ParaAltas || !!fakeupload">Eliminar</a>

            <input type="file" id="file" name="file" ref="file" @change="handleFileUpload($event)"
                v-validate="`size:10000|mimes:${formatos.formats}${(required) ? '|required' : ''}`" :class="[{'has-error' : errors.has('file')}]" />

            <span class='error' v-if="errors.has('file')">{{ errors.first('file') }}</span>
            <span class="error" v-if="errorformat && !!!errors.has('file')">Este tipo de fichero no esta
                permitido</span>

            <template v-if="!blnFormatoPdf">
                <popup-info :texto="'limitaciones_fichero'" :side="'left'"></popup-info>
            </template>
            <template v-else>
                <popup-info :texto="'fichero_pdf'" :side="'left'"></popup-info>
            </template>
        </template>

        <div class="loading" v-if="loading">
            <loading :small="true"></loading>
        </div>

    </div>

</template>

<script lang="js">

    import uploadIcon from '@/components/parts/icons/upload'
    import successIcon from '@/components/parts/icons/success'

    import popupInfo from '@/components/parts/popup-info';

    import loading from '@/components/parts/loading';

    import formatosPermitidos from '@/validator/docsformats.js';
    import formatoPdf from '@/validator/docsformatpdf.js';

    import { mapActions } from 'vuex';

    export default {
        name: 'dropzone',
        props: ['fakeupload', 'loading','required', 'blnFormatoPdf'],
        mounted() {
            if (this.blnFormatoPdf != undefined){
                this.formatos = formatoPdf;
            }else{
                 this.formatos = formatosPermitidos;
            }
        },
        data() {
            return {
                formatos: '',
                actualDoc: {
                    ficheroB64ParaAltas: '',
                    extension_adjunto: '',
                    fecha: '',
                    nombre: ''
                },
                errorformat: false
            }
        },
        computed: {
            textoUpload() {
                let mobile = ['iPhone', 'iPad', 'Android'];
                let isMobile = false;
                mobile.forEach(e => { if (navigator.userAgent.includes(e)) { isMobile = true; } });
                let r = (isMobile) ? 'Haz click para adjuntar el archivo' : 'Arrastra o selecciona el archivo para subir el documento'
                return r;
            },
        },
        methods: {
            
            handleFileUpload(event) {

                this.$validator.validateAll()
                    .then(itsOk => {

                        if (itsOk) {

                            let file = event.target.files[0];

                            if (!!file) {


                                let type = (!!file.type) ? file.type.split("/")[1] : file.name.split(".").pop();

                                let fechaactual = new Date();

                                this.actualDoc.fecha = fechaactual;

                                this.actualDoc.nombre = file.name;


                                if (this.formatos.formats.some(f => f.includes(type))) {

                                    if (!!this.formatos.relations[type]) {
                                        this.actualDoc.extension_adjunto = this.formatos.relations[type]
                                    } else {
                                        this.actualDoc.extension_adjunto = type;
                                    }


                                    this.showerror = false;

                                    this.getBase64(file).then(data => {
                                        this.actualDoc.ficheroB64ParaAltas = data;
                                        this.emit();
                                    });


                                    this.errorformat = false;

                                } else {
                                    this.errorformat = true;
                                    
                                }
                                
                            }
                        }

                    });
            },
            getBase64: function (file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            },
            emit() {
                this.$emit('emit', this.actualDoc);
            },
            eliminar() {
                this.reset();
                this.emit();
                this.$emit('eraseDoc');
            },
            reset() {
                this.errorformat = false;
                this.actualDoc = {
                    ficheroB64ParaAltas: '',
                    extension_adjunto: '',
                    fecha: ''
                };
                (document.getElementById("file")) ? document.getElementById("file").value = '' : null;
            }
        },
        components: {
            'upload-icon': uploadIcon,
            'success-icon': successIcon,
            'popup-info': popupInfo,
            'loading': loading

        }

    }
</script>

<style scoped lang="scss">
    /*DROPZONE*/

    @import '@/assets/css/colors.scss';

    .dropzone {
        width: 100%;
        min-height: 200px;
        background: #f2f2f2;
        padding: 20px;
        position: relative;
        border: 2px solid transparent;


        &[error="true"] {
            background: #ffd7d7;
            border: 2px solid red;
        }

        &[added="true"] {
            background: #f8fde9;
            border: 2px solid rgb(67, 134, 4);
        }

        svg {
            width: 40px;
            height: 40px;
            filter: grayscale(1);
            opacity: 0.5;
        }

        figure {
            font-size: 50px;
        }

        input {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            opacity: 0;
            cursor: pointer;
            z-index: 3;
            height: 100%;
        }

        p {
            text-align: center;
            margin-top: 10px;
        }

        .link {
            width: 100%;
            position: absolute;
            bottom: -25px;
            left: 0;
            text-align: center;
            z-index: 4;
            transition: .5s;
            opacity: 0;
            pointer-events: none;

            &[show=true] {
                transform: translateY(-40px);
                opacity: 1;
                pointer-events: visible;
            }
        }

        .error {
            position: absolute;
            width: 100%;
            bottom: 10px;
            left: 0;
            color: red;
            font-size: 12px;
            text-align: center;
        }

        .popup-info {
            top: 10px;
            right: 10px;
            z-index: 5;
        }

        .text {
            text-align: center;
        }

    }


    .pregunta-el {
        .dropzone {
            max-width: 100%;
        }
    }

    .empleo-anterior-el .dropzone {
        background: #e8e8e8;
    }

    [dark=true] {
        .dropzone {
            background: $almost-black;
        }
    }


    /*FIN DROPZONE*/
</style>


// WEBPACK FOOTER //
// src/components/parts/form/dropzone.vue